module.exports = __webpack_public_path__ + "img/1.e7a1f401.jpg";